import axios from '@/api/axios.config'
import type {
  EditorPageSaveInput,
  EditorPageSaveResult,
} from '@messenger/lotus/row-store'
import type { EditorPageContentBundle } from '@/utils/editor-text-box/editorTextBoxAdapter'

/**
 * How long a page-content request may stall before it rejects into its
 * caller's own handling: the same 60s the page PATCH uses, for stall
 * recovery, not latency policing. Every save gesture waits on the write and
 * holds the tab's save latch while it does, so a stalled write would leave the
 * editor unable to save until a reload; on expiry the save toasts and leaves
 * the drafts pending. The whole-product bleed check reads every page's
 * content before it gives the verdict Back waits on, so a stalled read ends
 * that walk without one.
 */
export const EDITOR_PAGE_CONTENT_STALL_TIMEOUT_MS = 60_000

export const getEditorPageContent = async (
  pageId: string,
  config: { timeout?: number } = {},
) =>
  await axios.get<EditorPageContentBundle>(
    `editor/pages/${pageId}/content`,
    config,
  )

/**
 * A box in `boxes` sent with an `expectedRevision` must still be at that
 * revision, or the route answers 409. Only `deleteBoxIds` removes a box —
 * leaving one out of `boxes` never deletes it.
 */
export const saveEditorPageContent = async (
  pageId: string,
  input: EditorPageSaveInput,
) =>
  await axios.post<EditorPageSaveResult>(
    `editor/pages/${pageId}/content`,
    input,
    { timeout: EDITOR_PAGE_CONTENT_STALL_TIMEOUT_MS },
  )
